(function () {
  document.querySelectorAll("[data-filter-drawer]").forEach((drawer) => {
    const section = drawer.closest("[data-collection-section]");
    const openButton = section?.querySelector("[data-filter-open]");
    const backdrop = section?.querySelector("[data-filter-backdrop]");
    const closeButtons = section?.querySelectorAll("[data-filter-close]") || [];
    const form = drawer.querySelector("[data-filter-form]");
    const submitButton = form?.querySelector("[data-filter-submit]");
    const mobileFilterQuery = window.matchMedia("(max-width: 768px)");
    let lastFocused = null;

    if (!section || !openButton || !backdrop) return;

    const getFocusableElements = () => [...drawer.querySelectorAll(
      "a[href], button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    )].filter((element) => element.getClientRects().length > 0);

    const closeFilters = ({ restoreFocus = false } = {}) => {
      const wasOpen = drawer.classList.contains("is-open");
      drawer.classList.remove("is-open");
      backdrop.classList.remove("is-open");
      openButton.setAttribute("aria-expanded", "false");
      if (mobileFilterQuery.matches) {
        drawer.setAttribute("aria-hidden", "true");
        drawer.inert = true;
      }
      document.documentElement.classList.remove("rush-filter-open");
      if (restoreFocus && wasOpen) (lastFocused || openButton).focus();
    };

    const openFilters = () => {
      if (!mobileFilterQuery.matches) return;
      lastFocused = document.activeElement;
      drawer.classList.add("is-open");
      backdrop.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      drawer.inert = false;
      openButton.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("rush-filter-open");
      window.requestAnimationFrame(() => {
        const initialFocus = drawer.querySelector("[data-filter-close]") || drawer;
        initialFocus.focus();
      });
    };

    const synchronizeFilterMode = () => {
      closeFilters();
      if (mobileFilterQuery.matches) {
        drawer.setAttribute("role", "dialog");
        drawer.setAttribute("aria-modal", "true");
        drawer.setAttribute("aria-hidden", "true");
        drawer.inert = true;
      } else {
        drawer.removeAttribute("role");
        drawer.removeAttribute("aria-modal");
        drawer.removeAttribute("aria-hidden");
        drawer.inert = false;
      }
    };

    openButton.addEventListener("click", openFilters);
    closeButtons.forEach((button) => button.addEventListener("click", () => closeFilters({ restoreFocus: true })));

    drawer.addEventListener("keydown", (event) => {
      if (!drawer.classList.contains("is-open")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        closeFilters({ restoreFocus: true });
        return;
      }
      if (event.key !== "Tab") return;
      const focusableElements = getFocusableElements();
      if (!focusableElements.length) {
        event.preventDefault();
        drawer.focus();
        return;
      }
      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form?.addEventListener("input", (event) => {
      if (event.target.matches("input, select") && submitButton) submitButton.textContent = "Apply filters";
    });

    if (mobileFilterQuery.addEventListener) {
      mobileFilterQuery.addEventListener("change", synchronizeFilterMode);
    } else {
      mobileFilterQuery.addListener(synchronizeFilterMode);
    }
    synchronizeFilterMode();
  });

})();
